import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import { ClockIcon, MapIcon } from '@heroicons/react/24/outline';
import useRouter from '@/hooks/useRouter';
import DropdownFilter from '@/components/DropdownFilter';

export default function SortBy(props) {
  const { withDistance = false } = props;

  const { location, history } = useRouter();

  const search = queryString.parse(location.search) || {};

  function onChange(order) {
    const search = queryString.parse(location.search) || {};

    search.order = order;
    delete search.page;

    history.push({
      pathname: location.pathname,
      search: queryString.stringify(_.extend({}, search))
    });
  }

  const orderMap = {
    Newest: {
      name: 'Newest',
      param: 'createdAt desc'
    },
    Active: {
      name: 'Active',
      param: 'lastActiveAt desc'
    },
    Distance: {
      name: 'Distance',
      param: 'distance asc'
    }
  };

  const reverseOrderMap = _.mapKeys(orderMap, function (value, _key) {
    return value.param;
  });

  return (
    <DropdownFilter subtitle="Sort by:" title={reverseOrderMap[search.order]?.name || 'Newest'}>
      <DropdownFilter.MenuItem
        icon={ClockIcon}
        title={orderMap.Newest.name}
        subtitle="Display recently created partners first."
        selected={!search.order || search.order === orderMap.Newest.param}
        onClick={() => onChange(orderMap.Newest.param)} />
      
      <DropdownFilter.MenuItem
        icon={ClockIcon}
        title={orderMap.Active.name}
        subtitle="Display partners by date they last logged in."
        selected={search.order === orderMap.Active.param}
        onClick={() => onChange(orderMap.Active.param)} />
      
      {withDistance &&
      <DropdownFilter.MenuItem
        icon={MapIcon}
        title={orderMap.Distance.name}
        subtitle="Display partners by distance from site."
        selected={search.order === orderMap.Distance.param}
        onClick={() => onChange(orderMap.Distance.param)} />

      }
    </DropdownFilter>);

}
SortBy.propTypes = {
  withDistance: PropTypes.bool
};
